exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".cvat-share-tree{height:256px}.cvat-empty-share-tree>.ant-typography{margin-top:10px}\n", ""]);
